import { createFileRoute } from '@tanstack/react-router'

import { PageBackButton } from '@/components/common/PageBackButton'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { useMyHeldPayments } from '@/hooks/use-driver-cash-query'
import { customerMethodLabel } from '@/lib/driver-cash'
import { formatDateTimeShort, formatVnd } from '@/lib/format'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute('/_app/_authed/_sidebar/driver/cash')({
    component: DriverCashPage,
})

/**
 * Tiền tài xế đang giữ (M-133): chỉ xem. Tài xế đưa tiền cho kế toán, kế toán
 * bấm "Nhận tiền" — tài xế không phải tạo phiếu nộp.
 */
function DriverCashPage() {
    const { data, isLoading } = useMyHeldPayments()
    const payments = data ?? []
    const held = payments.reduce((sum, p) => sum + p.amount, 0)

    return (
        <div className="space-y-4 page-pad">
            <div className="flex min-w-0 items-center gap-2">
                <PageBackButton className="-my-2 md:-my-1" />
                <h1 className="text-xl font-semibold">
                    {m.cashLedger_my_title()}
                </h1>
            </div>

            <Card>
                <CardHeader className="pb-2">
                    <CardTitle className="text-sm font-medium text-muted-foreground">
                        {m.cashLedger_held()}
                    </CardTitle>
                </CardHeader>
                <CardContent className="space-y-1">
                    <p
                        className="text-2xl font-semibold text-primary tabular-nums"
                        data-testid="held-amount"
                    >
                        {formatVnd(held)}
                    </p>
                    <p className="text-sm text-muted-foreground">
                        {m.cashLedger_my_desc()}
                    </p>
                </CardContent>
            </Card>

            <Card>
                <CardHeader>
                    <CardTitle className="text-base">
                        {m.cashLedger_held_orders()}
                    </CardTitle>
                </CardHeader>
                <CardContent>
                    {isLoading ? (
                        <p className="text-sm text-muted-foreground">
                            {m.common_loading()}
                        </p>
                    ) : payments.length === 0 ? (
                        <p className="text-sm text-muted-foreground">
                            {m.cashLedger_held_empty()}
                        </p>
                    ) : (
                        <ul className="divide-y">
                            {payments.map((p) => (
                                <li
                                    key={p.payment_id}
                                    className="flex items-center gap-3 py-2 text-sm"
                                >
                                    <span className="min-w-0 flex-1">
                                        <span className="block truncate font-medium">
                                            {p.order_code || '—'} ·{' '}
                                            {p.customer_name}
                                        </span>
                                        <span className="block truncate text-xs text-muted-foreground">
                                            {customerMethodLabel(
                                                p.payment_method,
                                            )}{' '}
                                            ·{' '}
                                            {formatDateTimeShort(
                                                p.collected_at,
                                            )}
                                        </span>
                                    </span>
                                    <span className="shrink-0 font-medium tabular-nums">
                                        {formatVnd(p.amount)}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    )}
                </CardContent>
            </Card>
        </div>
    )
}
